module.exports = __webpack_public_path__ + "media/images/official/about_point1-9634a79d4d79dd2f9de5fde4a11a9365.jpg";